// extracted by css-extract-rspack-plugin
export default {"message":"message-OX9SW1","inner":"inner-O8fFtB"};